import Actions from '../actions/actions';
import {
  deleteLocalFirst,
  retrieved,
  setBusy,
  setUnBusy,
  update,
} from './common/commonReducers';
import CtmAdCRUDActions from '../actions/CtmAdCRUDActions';
import { CtmAdModel } from '../model/CtmAdModel';
import { CtmAdsState } from '../interfaces/ctmAds';

interface ActionType {
  type: string;
  entity: CtmAdModel;
}

const initialState: CtmAdsState = {
  busy: false,
  entities: [],
};

export default function ctmAds(state = initialState, action: ActionType) {
  switch (action.type) {
    case CtmAdCRUDActions.busyAction:
      return setBusy(state);
    case CtmAdCRUDActions.unbusyAction:
      return setUnBusy(state);
    case CtmAdCRUDActions.retrievedAction:
      return retrieved(state, action);
    case CtmAdCRUDActions.updateAction:
      return update(state, action);
    case CtmAdCRUDActions.deleteLocalAction:
      return deleteLocalFirst(state, action);
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
